
(function () {
  window.omnibus_debug = true;

  function waitForVariantAndRender(retry = 0) {
    const input = document.querySelector('form[action="/cart/add"] [name="id"]');
    if (input && input.value) {
      console.log("[Omnibus] Variante iniziale trovata:", input.value);
      renderOmnibusLabel();
    } else {
      if (retry < 10) {
        console.log("[Omnibus] In attesa della variante selezionata...");
        setTimeout(() => waitForVariantAndRender(retry + 1), 300);
      } else {
        console.warn("[Omnibus] Nessuna variante trovata dopo diversi tentativi");
      }
    }
  }

  function renderOmnibusLabel() {
    console.log("[Omnibus] Avvio rendering dicitura prezzo");
    const dataTag = document.getElementById("omnibus-data");
    if (!dataTag) {
      console.warn("[Omnibus] Tag #omnibus-data non trovato nel DOM");
      return;
    }

    try {
      const data = JSON.parse(dataTag.textContent);
      const variantId = getCurrentVariantId();
      const variant = data.variants.find((v) => v.id == variantId);

      console.log("[Omnibus] Variante attiva:", variant);

      if (!variant || !variant.metafield) {
        console.warn("[Omnibus] Variante o Metafield non trovati");
        return;
      }

      const currentPrice = parseFloat(variant.price);
      let lowest = 0;

      if (
        typeof variant.metafield.lowest_30_days === "object" &&
        variant.metafield.lowest_30_days.price
      ) {
        lowest = parseFloat(variant.metafield.lowest_30_days.price);
      } else if (typeof variant.metafield.lowest_30_days === "number") {
        lowest = parseFloat(variant.metafield.lowest_30_days);
      } else if (typeof variant.metafield.lowest30Days === "number") {
        lowest = parseFloat(variant.metafield.lowest30Days);
      }

      console.log("[Omnibus] Prezzo corrente:", currentPrice);
      console.log("[Omnibus] Prezzo minimo 30gg:", lowest);

      removeExistingLabel();

      if (!isNaN(currentPrice) && !isNaN(lowest) && lowest > currentPrice) {
        const priceElement = document.querySelector(".product-info__price, .product__price, .product-price, .product-price-wrap");
        if (priceElement) {
          const label = document.createElement("div");
          label.className = "lowest-price-omnibus";
          label.style.cssText =
            "margin-top: 10px; color: black; font-size: 12px; font-weight: bold; display: block;";
          label.innerHTML =
            'Prezzo più basso ultimi 30gg: <strong><s>' +
            "€ " + lowest.toFixed(2).replace(".", ",") +
            "</s></strong>";
          priceElement.insertAdjacentElement("afterend", label);
          console.log("[Omnibus] Dicitura inserita subito dopo il prezzo");
        }
      } else {
        console.log("[Omnibus] Condizione non soddisfatta, nessuna dicitura mostrata.");
      }
    } catch (e) {
      console.error("[Omnibus] Errore nel parsing dei dati:", e);
    }
  }

  function getCurrentVariantId() {
    const variantInput = document.querySelector('form[action="/cart/add"] [name="id"]');
    const id = variantInput ? variantInput.value : null;
    console.log("[Omnibus] ID variante corrente:", id);
    return id;
  }

  function removeExistingLabel() {
    const oldLabel = document.querySelector(".lowest-price-omnibus");
    if (oldLabel) {
      oldLabel.remove();
      console.log("[Omnibus] Dicitura precedente rimossa");
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    console.log("[Omnibus] DOM completamente caricato");
    waitForVariantAndRender();

    document
      .querySelector("form.product-form")
      ?.addEventListener("change", function () {
        console.log("[Omnibus] Cambio variante rilevato");
        setTimeout(renderOmnibusLabel, 100);
      });
  });
})();


